import { Box, Skeleton } from "@mui/material";
import colors from "../../Constants/colors";

export function EvaluationSkeleton() {
  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1.5 }}>
          <Skeleton
            variant="rounded"
            width={80}
            height={80}
            sx={{ flexShrink: 0 }}
          />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="60%" height={32} />
            <Skeleton variant="text" width="40%" height={24} sx={{ mt: 1 }} />
          </Box>
        </Box>
        <Skeleton
          variant="rounded"
          height={80}
          sx={{
            bgcolor: `${colors.gray100}`,
            borderRadius: 2,
          }}
        />
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} variant="rounded" height={120} sx={{ mb: 1 }} />
        ))}
      </Box>
    </Box>
  );
}
